<template>
  <Modal class-name="vertical-center-modal" v-model="isSync" width="45%" title="同步模板消息">
    <div class="form-wrapper">
      <div class="explain">
        <div class="explain-title">说明：</div>
        <div class="explain-tip">
          <div>1、公众号必须为“服务号”才能进行消息模板推送；</div>
          <div>2、开通模板时，须选择“IT科技/互联网|电子商务”行业，如下图所示；</div>
          <div>3、申请理由随意填写，并开通自定义菜单。若已经开通过消息模板，需确保行业一致，不一致可在腾讯公众号管理后台修改</div>
        </div>
      </div>
      <div class="padding-tb-10 margin-top-10">
        <div class="part-div">
          <el-row>
            <el-col :span="11">
              <div class="img-wrap img-left">
                <div class="img-box">
                  <img style="width: 100%" src="@/assets/img/kfc/steps.png" alt="">
                </div>
              </div>
            </el-col>
            <el-col :span="13">
              <div style="margin: 50px 20px;">
                <div>
                  <span class="step-btn">步骤一</span>
                </div>
                <div class="step-tip">登录腾讯公众号后台，完成公众号模版消息开通</div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="padding-tb-10">
        <div class="part-div">
          <el-row>
            <el-col :span="24">
              <div style="margin: 50px 35px;">
                <div>
                  <span class="step-btn">步骤二</span>
                </div>
                <div class="step-tip">
                  <span>点击开始同步按钮进行模板同步</span>
                  <span class="sync" @click="sycn()">开始同步</span>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div slot="footer"></div>
    <SyncTemplateInfo ref="info"></SyncTemplateInfo>
  </Modal>
</template>

<script>
import { Modal } from 'view-design'
import SyncTemplateInfo from './SyncTemplateInfo.vue'
export default {
  name: 'SyncTemplate',
  components: {
    Modal,
    SyncTemplateInfo
  },
  props: {},
  created() {},
  data() {
    return {
      isSync: false,
      appId: ''
    }
  },
  computed: {},
  methods: {
    init(appId) {
      this.isSync = true
      this.appId = appId
    },
    sycn() {
      this.$refs.info.init(this.appId)
    }
  }
}
</script>

<style scoped>
.color-666 {
  color: #666666;
}
.color-222 {
  color: #222222;
}
.font-weight-bold {
  font-weight: bold;
}
.text-right {
  text-align: right;
}
.padding-5 {
  padding: 5px;
}
.padding-tb-10 {
  padding: 10px 0;
}
.margin-top-10 {
  margin-top: 10px;
}
.normal-font {
  color: #d63036;
  font-size: 14px;
}
.form-wrapper .explain {
  font-family: Alibaba-PuHuiTi-R;
  font-size: 13px;
  color: #d63036;
  line-height: 20px;
  background: #ffffff;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.form-wrapper .explain .explain-title {
  font-family: Alibaba-PuHuiTi-M;
  min-width: 45px;
}
.form-wrapper .explain .explain-tip {
  font-family: Alibaba-PuHuiTi-R;
  color: #999999;
}
.form-wrapper .part-div {
  background: #fafafa;
  border-radius: 4px;
}
.form-wrapper .part-div .img-wrap {
  margin: 20px;
}
.form-wrapper .part-div .img-left {
  margin: 20px 20px 20px 35px;
}
.form-wrapper .part-div .img-right {
  margin: 20px 35px 20px 20px;
}
.form-wrapper .part-div .img-wrap .img-box {
  background: #ffffff;
}
.form-wrapper .part-div .img-wrap .img-box img {
  width: 100%;
}
.form-wrapper .part-div .step-btn {
  background-image: linear-gradient(90deg, #ffbb47 6%, #d63036 89%, #d63036 89%);
  border-radius: 17px;
  color: #ffffff;
  font-family: Alibaba-PuHuiTi-R;
  font-size: 16px;
  padding: 3px 15px;
}
.form-wrapper .part-div .step-tip {
  font-family: Alibaba-PuHuiTi-M;
  font-size: 14px;
  color: #222222;
  padding-top: 20px;
}
.form-wrapper .part-div .step-tip .sync {
  font-family: Alibaba-PuHuiTi-R;
  font-size: 14px;
  color: #d63036;
  padding: 5px 15px;
  border: 1px solid #d63036;
  margin-left: 10px;
  cursor: pointer;
  white-space: nowrap;
}
>>> .ivu-modal-body {
  padding: 16px;
}
>>> .ivu-modal-content {
  border-radius: 0;
}
>>> .vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}
>>> .vertical-center-modal .ivu-modal {
  top: 0;
}
>>> .ivu-modal-footer {
  border-top: none;
  padding: 0;
}
>>> .v-transfer-dom .v-modal {
  z-index: 1 !important;
}
>>> .v-transfer-dom .ivu-message {
  z-index: 9999 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/open/components/SyncTemplate.vue